import React, { useState } from "react";
import Hero from "../components/Hero";
import FeaturedLogos from "../components/FeaturedLogos";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import Catalog from "../components/Catalog";
import AboutCard from "../components/AboutCard";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import EmailCaptureModal from "../components/EmailCaptureModal";

export default function Landing() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);

  return (
    <div className="dark-site bg-white">
      <Hero onStart={openModal} />
      <FeaturedLogos />
      <Services onStart={openModal} />
      <Testimonials />
      <Catalog onStart={openModal} />
      <AboutCard onStart={openModal} />
      <FAQ />
      <Footer />
      <EmailCaptureModal open={modalOpen} onOpenChange={setModalOpen} />
    </div>
  );
}
